import React from "react";
import { Select } from "antd";

const { Option } = Select;

function Filter({ searchText, setSearchText, selectedStatus, setSelectedStatus, onReset }) {
  return (
    <div className="row filter-row mb-3 align-items-center">
      <div className="col-sm-6 col-md-5 col-lg-4 mb-2">
        <div className="form-group mb-0">
          <input
            type="text"
            className="form-control"
            placeholder="Search by name, email, organization, headline..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      <div className="col-sm-4 col-md-3 col-lg-3 mb-2">
        <Select
          className="w-100"
          value={selectedStatus}
          onChange={(value) => setSelectedStatus(value)}
          style={{ height: "44px" }}
          placeholder="Filter by Status"
        >
          <Option value="">All Statuses</Option>
          <Option value="ACTIVE">Active</Option>
          <Option value="DRAFT">Draft</Option>
          <Option value="INACTIVE">Inactive</Option>
        </Select>
      </div>
      <div className="col-sm-2 col-md-2 col-lg-2 mb-2">
        <button
          type="button"
          className="btn btn-secondary btn-block w-100"
          style={{ height: "44px" }}
          onClick={onReset}
        >
          <i className="fa fa-refresh mr-1" /> Reset
        </button>
      </div>
    </div>
  );
}

export default Filter;
